<script>
import axios from "axios";
import { debounce } from "lodash";

export default {
  components: {},
  name: "university-list",
  props: {
    cities: {
      type: Array,
      required: true,
    },
    sectors: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    subjects: {
      type: Array,
      required: false,
    },
    isFaculty: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      q: this.getQueryParam("q") || "",
      showFilters: !!(this.getQueryParam("sector") || this.getQueryParam("city_id") || this.getQueryParam("field_id")),
      sector: this.getQueryParam("sector") || '',
      city_id: this.getQueryParam("city_id") || '',
      field_id: this.getQueryParam("field_id") || '',
      subject_id: this.getQueryParam("subject_id") || '',

      isLoadingList: false,
    };
  },
  methods: {
    submitFilters() {
      this.getUnisByFilters();
    },
    clearFilters() {
      this.sector = '';
      this.city_id = '';
      this.field_id = '';
      this.subject_id = ''; 

      this.q = '';

      const params = new URLSearchParams(window.location.search);
      params.delete("sector");
      params.delete("city_id");
      params.delete("subject_id"); 
      params.delete("q");

      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.pushState(null, "", newUrl);

    },
    hideAndClearFilters() {
      this.showFilters = false;
      this.clearFilters();
    },
    setShowFilter(e) {
      e.preventDefault();
      this.showFilters = !this.showFilters;
    },
    getListBySearchTerm: debounce(function () {
      this.isLoadingList = true;

      const params = new URLSearchParams();
      params.set("q", this.q);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.pushState(null, "", newUrl);

      axios
        .get(this.isFaculty ? '/faculties' : '/universities', {
          params: {
            title: this.q,
          },
        })
        .then((response) => {
          document.getElementById("list").innerHTML = response.data;
          this.isLoadingList = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoadingList = false;
        });
    }, 500),
    getUnisByFilters: debounce(function () {
      this.isLoadingList = true;

      const params = new URLSearchParams();
      if (this.sector) params.set("sector", this.sector);
      if (this.city_id) params.set("city_id", this.city_id);
      if (this.subject_id) params.set("subject_id", this.subject_id);
      if (this.field_id) params.set("field_id", this.field_id);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.pushState(null, "", newUrl);

      axios
        .get(this.isFaculty ? '/faculties' : '/universities', {
          params: {
            q: this.q,
            sector_id: this.sector,
            city_id: this.city_id,
            field_id: this.field_id,
            subject_id: this.subject_id,
          },
        })
        .then((response) => {
          document.getElementById("list").innerHTML = response.data;
          this.isLoadingList = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoadingList = false;
        });
    }, 500),
    getQueryParam(paramName) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(paramName);
    },
  },
  watch: {
    q() {
      this.getListBySearchTerm();
    },
  },
};
</script>
